export default {
  namespaced: true,

  state: {
    formKey: 0,
    currentStoreName: false,
    showFugaUsage: false,
    showFormPersonalDetails: false,
    showFormBusinessDetails: false,
    showFormBillingAddress: false,
    showAddPaymentMethod: false,
    showAddVoucher: false,
    showFormCreditCard: false,
    showFormSepaDD: false,
    showFormSepaSofort: false,
    showFormAddress: false,
    showFormPresent: false,
    showFormLevel: false,
    showFormEditCustomer: false,
    showFormEditTeam: false,
    showFormChangeTeamOwner: false,
    showFormDelete: false,
    showFormDeleteTeamUser: false,
    showFormCreateTeam: false,
    showFormEditProject: false,
    showSelectedTeam: false,
    showFormCreateProject: false,
    showProjectToken: false,
    showFormInviteUser: false,
    showFormCreateContainer: false,
    showFormPoolsEmk: false,
    showFormAddonsEmk: false,
    showFormCredentialsEmk: false,
    showFormDNSEmk: false,
    showFormHAEmk: false,
    showFormCreateServiceAccount: false,
    showFormResetServiceAccount: false,
    showFormDeleteServiceAccount: false,
    showFormMaintenanceEmk: false,
    showFormExtensionsEmk: false,
    showFormHibernationEmk: false,
    showFormDirectHibernationEmk: false,
    showFormReconcileEmk: false,
    showFormAccessEmk: false,
    showFormUpgradeEmk: false,
    showFormRotateKubeConfigEmk: false,
    showFormClusterPurpose: false,
    showFormDeleteEmk: false,
    showFormEditContainer: false,
    showFormCreateVolume: false,
    showFormCreateVolumeBackup: false,
    showVolumeRemoveVolumeFromInstanceForm: false,
    showRestoreVolumeBackupForm: false,
    showFormAcceptTransferVolume: false,
    showFormBootableVolume: false,
    showFormCreateVolumeSnapShot: false,
    showVolumeSnapShot: false,
    showFormEditVolume: false,
    showVolumeTransferData: false,
    showFormCreateLoadBalancer: false,
    showFormDeleteLoadBalancer: false,
    showFormEditLoadBalancer: false,
    showFormBYOIP: false,
    showFormAssociateIp: false,
    showFormAllocateIp: false,
    showFormCreateSecurityGroup: false,
    showFormCreateSGRule: false,
    showFormCreateNetwork: false,
    showFormCreateSubnet: false,
    showFormShowSubnet: false,
    showFormCreatePort: false,
    showFormCreateRouter: false,
    showFormCreateKeyPair: false,
    showFormCreateSecret: false,
    showFormUploadPublicKey: false,
    showFormCreateFolder: false,
    showFormCreateAppCredential: false,
    showResizeInstanceForm: false,
    showAddVolumeForm: false,
    showAddSGForm: false,
    showEditSGForm: false,
    showAttachInterfaceForm: false,
    showInstanceModal: false,
    showDeleteInstanceForm: false,
    showAddInterfaceForm: false,
    showDetachInterfaceRouterForm: false,
    showDetachInterfaceForm: false,
    showVolumeUploadImageForm: false,
    showVolumeModal: false,
    showVolumeToInstanceForm: false,
    showResizeVolumeForm: false,
    showCreateImageForm: false,
    showCreateDNSZoneForm: false,
    showCreateDNSRecordForm: false,
    showCreateDatabaseBackupForm: false,
    showQuotaIncreaseForm: false,
    showExpiryObjectForm: false,
    showChangeDnsRecordForm: false,
    showCreateServerBackupForm: false,
    showContainerDetails: false,
    showContainerAccessForm: false,
    showReverseUnSetForm: false,
    showIpDescription: false,
    showAddListenerForm: false,
    showFormEditSubnet: false,
  },

  mutations: {
    UPDATE_KEY(state) {
      state.formKey += 1;
    },

    SET_CURRENT_STORENAME(state, storeName) {
      state.currentStoreName = storeName;
    },

    SHOW_FUGA_USAGE(state, bool) {
      state.showFugaUsage = bool;
    },

    SHOW_FORM_PERSONAL_DETAILS(state, bool) {
      state.showFormPersonalDetails = bool;
    },

    SHOW_FORM_BUSINESS_DETAILS(state, bool) {
      state.showFormBusinessDetails = bool;
    },

    SHOW_FORM_EDIT_CUSTOMER(state, bool) {
      state.showFormEditCustomer = bool;
    },

    SHOW_FORM_EDIT_TEAM(state, bool) {
      state.showFormEditTeam = bool;
    },

    SHOW_FORM_CHANGE_TEAM_OWNER(state, bool) {
      state.showFormChangeTeamOwner = bool;
    },

    SHOW_FORM_DELETE_TEAM_USER(state, bool) {
      state.showFormDeleteTeamUser = bool;
    },

    SHOW_FORM_CREATE_TEAM(state, bool) {
      state.showFormCreateTeam = bool;
    },

    SHOW_FORM_EDIT_PROJECT(state, bool) {
      state.showFormEditProject = bool;
    },

    SHOW_SELECTED_TEAM(state, bool) {
      state.showSelectedTeam = bool;
    },

    SHOW_FORM_EDIT_CREDENTIAL(state, bool) {
      state.showFormEditCredential = bool;
    },

    SHOW_FORM_CREATE_PROJECT(state, bool) {
      state.showFormCreateProject = bool;
    },

    SHOW_PROJECT_TOKEN(state, bool) {
      state.showProjectToken = bool;
    },

    SHOW_FORM_BILLING_ADDRESS(state, bool) {
      state.showFormBillingAddress = bool;
    },

    SHOW_FORM_INVITE_USER(state, bool) {
      state.showFormInviteUser = bool;
    },

    SHOW_ADD_PAYMENT_METHOD(state, bool) {
      state.showAddPaymentMethod = bool;
    },

    SHOW_ADD_VOUCHER(state, bool) {
      state.showAddVoucher = bool;
    },

    SHOW_FORM_CREDIT_CARD(state, bool) {
      state.showFormCreditCard = bool;
    },

    SHOW_FORM_SEPA_DD(state, bool) {
      state.showFormSepaDD = bool;
    },

    SHOW_FORM_SEPA_SOFORT(state, bool) {
      state.showFormSepaSofort = bool;
    },

    SHOW_FORM_ADDRESS(state, bool) {
      state.showFormAddress = bool;
    },

    SHOW_FORM_LEVEL(state, bool) {
      state.showFormLevel = bool;
    },

    SHOW_FORM_PRESENT(state, bool) {
      state.showFormPresent = bool;
    },

    SHOW_FORM_DELETE(state, bool) {
      state.showFormDelete = bool;
    },

    SHOW_FORM_CREATE_CONTAINER(state, bool) {
      state.showFormCreateContainer = bool;
    },

    SHOW_FORM_UPGRADE_EMK(state, bool) {
      state.showFormUpgradeEmk = bool;
    },

    SHOW_FORM_POOLS_EMK(state, bool) {
      state.showFormPoolsEmk = bool;
    },

    SHOW_FORM_ADDONS_EMK(state, bool) {
      state.showFormAddonsEmk = bool;
    },

    SHOW_FORM_CREDENTIALS_EMK(state, bool) {
      state.showFormCredentialsEmk = bool;
    },

    SHOW_FORM_DNS_EMK(state, bool) {
      state.showFormDNSEmk = bool;
    },

    SHOW_FORM_HA_EMK(state, bool) {
      state.showFormHAEmk = bool;
    },

    SHOW_FORM_CREATE_SERVICE_ACCOUNT(state, bool) {
      state.showFormCreateServiceAccount = bool;
    },

    SHOW_FORM_RESET_SERVICE_ACCOUNT(state, bool) {
      state.showFormResetServiceAccount = bool;
    },

    SHOW_FORM_DELETE_SERVICE_ACCOUNT(state, bool) {
      state.showFormDeleteServiceAccount = bool;
    },

    SHOW_FORM_MAINTENANCE_EMK(state, bool) {
      state.showFormMaintenanceEmk = bool;
    },

    SHOW_FORM_EXTENSIONS_EMK(state, bool) {
      state.showFormExtensionsEmk = bool;
    },

    SHOW_FORM_HIBERNATION_EMK(state, bool) {
      state.showFormHibernationEmk = bool;
    },

    SHOW_FORM_DIRECT_HIBERNATION_EMK(state, bool) {
      state.showFormDirectHibernationEmk = bool;
    },

    SHOW_FORM_RECONCILE_EMK(state, bool) {
      state.showFormReconcileEmk = bool;
    },

    SHOW_FORM_ACCESS_EMK(state, bool) {
      state.showFormAccessEmk = bool;
    },

    SHOW_FORM_ROTATE_KUBECONFIG_EMK(state, bool) {
      state.showFormRotateKubeConfigEmk = bool;
    },

    SHOW_FORM_CLUSTER_PURPOSE(state, bool) {
      state.showFormClusterPurpose = bool;
    },

    SHOW_FORM_DELETE_EMK(state, bool) {
      state.showFormDeleteEmk = bool;
    },

    SHOW_FORM_EDIT_CONTAINER(state, bool) {
      state.showFormEditContainer = bool;
    },

    SHOW_FORM_CREATE_VOLUME(state, bool) {
      state.showFormCreateVolume = bool;
    },

    SHOW_FORM_CREATE_VOLUME_BACKUP(state, bool) {
      state.showFormCreateVolumeBackup = bool;
    },

    SHOW_FORM_ACCEPT_TRANSFER_VOLUME(state, bool) {
      state.showFormAcceptTransferVolume = bool;
    },

    SHOW_FORM_CREATE_VOLUME_SNAPSHOT(state, bool) {
      state.showFormCreateVolumeSnapShot = bool;
    },

    SHOW_FORM_BOOTABLE_VOLUME(state, bool) {
      state.showFormBootableVolume = bool;
    },

    SHOW_VOLUME_SNAPSHOT(state, bool) {
      state.showVolumeSnapShot = bool;
    },

    SHOW_FORM_EDIT_VOLUME(state, bool) {
      state.showFormEditVolume = bool;
    },

    SHOW_VOLUME_TRANSFER_DATA(state, bool) {
      state.showVolumeTransferData = bool;
    },

    SHOW_FORM_CREATE_LOAD_BALANCER(state, bool) {
      state.showFormCreateLoadBalancer = bool;
    },

    SHOW_FORM_DELETE_LOAD_BALANCER(state, bool) {
      state.showFormDeleteLoadBalancer = bool;
    },

    SHOW_FORM_EDIT_LOAD_BALANCER(state, bool) {
      state.showFormEditLoadBalancer = bool;
    },

    SHOW_FORM_BYOIP(state, bool) {
      state.showFormBYOIP = bool;
    },

    SHOW_FORM_ASSOCIATE_IP(state, bool) {
      state.showFormAssociateIp = bool;
    },

    SHOW_FORM_ALLOCATE_IP(state, bool) {
      state.showFormAllocateIp = bool;
    },

    SHOW_FORM_CREATE_SECURITY_GROUP(state, bool) {
      state.showFormCreateSecurityGroup = bool;
    },

    SHOW_FORM_CREATE_SG_RULE(state, bool) {
      state.showFormCreateSGRule = bool;
    },

    SHOW_FORM_CREATE_NETWORK(state, bool) {
      state.showFormCreateNetwork = bool;
    },

    SHOW_FORM_CREATE_SUBNET(state, bool) {
      state.showFormCreateSubnet = bool;
    },

    SHOW_FORM_SHOW_SUBNET(state, bool) {
      state.showFormShowSubnet = bool;
    },

    SHOW_FORM_CREATE_PORT(state, bool) {
      state.showFormCreatePort = bool;
    },

    SHOW_FORM_EDIT_SUBNET(state, bool) {
      state.showFormEditSubnet = bool;
    },

    SHOW_FORM_CREATE_ROUTER(state, bool) {
      state.showFormCreateRouter = bool;
    },

    SHOW_FORM_CREATE_KEYPAIR(state, bool) {
      state.showFormCreateKeyPair = bool;
    },

    SHOW_FORM_CREATE_SECRET(state, bool) {
      state.showFormCreateSecret = bool;
    },

    SHOW_FORM_UPLOAD_PUBLIC_KEY(state, bool) {
      state.showFormUploadPublicKey = bool;
    },

    SHOW_FORM_CREATE_FOLDER(state, bool) {
      state.showFormCreateFolder = bool;
    },

    SHOW_FORM_CREATE_APP_CREDENTIAL(state, bool) {
      state.showFormCreateAppCredential = bool;
    },

    SHOW_FORM_RESIZE_INSTANCE(state, bool) {
      state.showResizeInstanceForm = bool;
    },

    SHOW_FORM_ADD_VOLUME(state, bool) {
      state.showAddVolumeForm = bool;
    },

    SHOW_FORM_ADD_SG(state, bool) {
      state.showAddSGForm = bool;
    },

    SHOW_FORM_EDIT_SG(state, bool) {
      state.showEditSGForm = bool;
    },

    SHOW_FORM_ATTACH_INTERFACE(state, bool) {
      state.showAttachInterfaceForm = bool;
    },

    SHOW_INSTANCE_MODAL(state, bool) {
      state.showInstanceModal = bool;
    },

    SHOW_FORM_DELETE_INSTANCE(state, bool) {
      state.showDeleteInstanceForm = bool;
    },

    SHOW_FORM_ADD_INTERFACE(state, bool) {
      state.showAddInterfaceForm = bool;
    },

    SHOW_FORM_DETACH_INTERFACE_ROUTER(state, bool) {
      state.showDetachInterfaceRouterForm = bool;
    },

    SHOW_FORM_DETACH_INTERFACE(state, bool) {
      state.showDetachInterfaceForm = bool;
    },

    SHOW_FORM_VOLUME_UPLOAD_IMAGE(state, bool) {
      state.showVolumeUploadImageForm = bool;
    },

    SHOW_VOLUME_MODAL(state, bool) {
      state.showVolumeModal = bool;
    },

    SHOW_FORM_ADD_VOLUME_TO_INSTANCE(state, bool) {
      state.showVolumeToInstanceForm = bool;
    },

    SHOW_FORM_REMOVE_VOLUME_TO_INSTANCE(state, bool) {
      state.showVolumeRemoveVolumeFromInstanceForm = bool;
    },

    SHOW_FORM_RESTORE_VOLUME_BACKUP(state, bool) {
      state.showRestoreVolumeBackupForm = bool;
    },

    SHOW_FORM_RESIZE_VOLUME(state, bool) {
      state.showResizeVolumeForm = bool;
    },

    SHOW_FORM_CREATE_IMAGE(state, bool) {
      state.showCreateImageForm = bool;
    },

    SHOW_FORM_CREATE_DNS_ZONE(state, bool) {
      state.showCreateDNSZoneForm = bool;
    },

    SHOW_FORM_CREATE_DNS_RECORD(state, bool) {
      state.showCreateDNSRecordForm = bool;
    },

    SHOW_FORM_CREATE_DATABASE_BACKUP(state, bool) {
      state.showCreateDatabaseBackupForm = bool;
    },

    SHOW_FORM_QUOTA_INCREASE(state, bool) {
      state.showQuotaIncreaseForm = bool;
    },

    SHOW_FORM_EXPIRY_OBJECT(state, bool) {
      state.showExpiryObjectForm = bool;
    },

    SHOW_FORM_CHANGE_DNS_RECORD(state, bool) {
      state.showChangeDnsRecordForm = bool;
    },

    SHOW_FORM_CREATE_INSTANCE_BACKUP(state, bool) {
      state.showCreateServerBackupForm = bool;
    },

    SHOW_CONTAINER_DETAILS(state, bool) {
      state.showContainerDetails = bool;
    },

    SHOW_CONTAINER_ACCESS_FORM(state, bool) {
      state.showContainerAccessForm = bool;
    },

    SHOW_FORM_REVERSE_UN_SET(state, bool) {
      state.showReverseUnSetForm = bool;
    },

    SHOW_FORM_IP_DESCRIPTION(state, bool) {
      state.showIpDescription = bool;
    },

    SHOW_FORM_ADD_LISTENER(state, bool) {
      state.showAddListenerForm = bool;
    },
  }
}
